import React, {
  Fragment,
  useContext,
  useState,
  useEffect,
  useRef,
} from "react";
import { useHistory } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import AuthContext from "../../context/auth/AuthContext";
import AlertContext from "../../context/alert/AlertContext";
import ConfigContext from "../../context/config/ConfigContext";
import CardContext from "../../context/card/CardContext";
import EmployeeContext from "../../context/employee/EmployeeContext";
import NavigationContext from "../../context/navigation/NavigationContext";
import GroupContext from "../../context/group/GroupContext";
import Preloader from "./../layout/Preloader";
import ActionMenu from "./../layout/ActionMenu";
import { getStateByCode, getStateList } from "../../utils/Lookup";
import useForm from "../../hooks/useForm";
import useTokenCheck from "../../hooks/useTokenCheck";
import NumberFormat from "react-number-format";
import usePageTitle from "../../hooks/usePageTitle";

const Employee = (props) => {
  const authContext = useContext(AuthContext);
  const { token } = authContext;
  const configContext = useContext(ConfigContext);
  const {
    getConfigValueByCode,
    getConfigValueByNameSponser,
    getConfigValueByName,
  } = configContext;
  const cardContext = useContext(CardContext);
  const { selectedCard } = cardContext;
  const alertContext = useContext(AlertContext);
  const { setAlert, clearAlerts } = alertContext;
  const groupContext = useContext(GroupContext);
  const { groups, getGroups, groupsLoading } = groupContext;
  const employeeContext = useContext(EmployeeContext);
  const {
    employeesLoading,
    selectedEmployee,
    createEmployee,
    updateEmployee,
    getEmployees,
    savedCriteria,
  } = employeeContext;
  const navigationContext = useContext(NavigationContext);
  const { setNavigationPage } = navigationContext;
  const history = useHistory();
  console.log("###Current Employee:", selectedEmployee);
  const [employee, setEmployee] = useState({
    id: "",
    employeeid: "",
    firstName: "",
    lastName: "",
    groupName: "",
    groupId: "",
    employeeaddress: "",
    city: "",
    stateValue: "",
    state: "",
    zipCode: "",
    email: "",
    phonenumber: "",
    cardNumber: "",
    contractId: "",
    contractName: "",
  });

  const {
    id,
    employeeid,
    firstName,
    lastName,
    groupId,
    employeeaddress,
    city,
    state,
    zipCode,
    phonenumber,
    cardNumber,
    contractId,
  } = employee;

  const stateList = getStateList();

  const firstNameRef = useRef(null);
  const lastNameRef = useRef(null);
  const employeeidRef = useRef(null);
  const groupIdRef = useRef(null);
  const employeeaddressRef = useRef(null);
  const cityRef = useRef(null);
  const stateRef = useRef(null);
  const zipCodeRef = useRef(null);
  const emailRef = useRef(null);
  const phonenumberRef = useRef(null);
  const cardNumberRef = useRef(null);
  const contractIdRef = useRef(null);
  const { hasTokenExpired } = useTokenCheck();
  const [valueChanged, setValueChanged] = useState(false);

  usePageTitle({
    appTitle: props.appTitle,
    pageTitle: "Employee Details",
  });

  // console.log("setting navigation back", props.location.state.prevPath);
  // const prevLocation = props.location.state.prevPath;

  const onChange = async (e) => {
    // await hasTokenExpired();
    // let value = "";
    // if (e.target.name === "groupName") {
    //   getGroupId();
    // }
    console.log(`Setting [${e.target.name}]: ${e.target.value}`);
    setEmployee({ ...employee, [e.target.name]: e.target.value });
    setValueChanged(true);
  };
  const phoneNoChange = (value, floatValue) => {
    setEmployee({ ...employee, phonenumber: value });
    setUnformattedValues({
      ...unformattedValues,
      phonenumber: floatValue?.toString(),
    });
    setValueChanged(true);
  };

  const cancelAction = async () => {
    clearAlerts();
    // if (dataUpdated) {
    //   console.log("Data Updated...Reloading");
    //   loadSearchResults();
    //   setDataUpdated(false);
    // }
    // console.log("setting navigation back", prevLocation);
    setNavigationPage("Employee");
    history.goBack();
  };

  const loadSearchResults = async () => {
    console.log("$$SEARCH CRITERIA: ", savedCriteria);
    if (!savedCriteria) {
      console.log("$$NO SEARCH CRITERIA: ", savedCriteria);
      return;
    }
    try {
      console.log("$$RES LOAD: ", savedCriteria);
      const res = await getEmployees(savedCriteria, token);
      console.log("$$RES: ", res);
      if (res && res.msgCode) {
        const msg = getConfigValueByCode(
          "generalConfig",
          "RESPONSE_MSG",
          res.msgCode
        );
        clearAlerts();
        setAlert(msg, "warning");
      } else if (res.length === 0) {
        clearAlerts();
        const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 469);
        setAlert(msg, "warning");
      }
    } catch (err) {
      console.log("$ERR:", err);
      if (err.msgCode) {
        const msg = getConfigValueByCode(
          "generalConfig",
          "RESPONSE_MSG",
          err.msgCode
        );
        clearAlerts();
        setAlert(msg, "warning");
      }
      clearAlerts();
      const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 475);
      setAlert(msg, "danger");
    }
  };

  const submitForm = async (e) => {
    await hasTokenExpired();
    e.preventDefault();
    if (
      employeeid !== "" &&
      firstName !== "" &&
      lastName !== "" &&
      cardNumber !== "" &&
      groupId !== "" &&
      contractId !== ""
    ) {
      console.log("Submitting employee", employee);
      const payload = { ...employee };

      delete payload[""];
      delete payload["groupName"];
      delete payload["contractName"];
      // const employeeid2 = employee.employeeid;
      // delete employee["employeeid"];
      // payload["employeeid2"] = employee.employeeid;
      // payload["stateValue"] = getStateByCode(employee.state);
      // delete payload["employeeid"];
      clearAlerts();
      try {
        let res = null;
        if (id) {
          console.log("$UPD:", id);
          delete payload["cardNumber"];
          res = await updateEmployee(payload, token);
        } else {
          console.log("$CRT:", id);
          res = await createEmployee(payload, token);
        }
        console.log("$$RES: ", res);
        let msg = ";";
        if (res && res.msgCode) {
          msg = getConfigValueByCode(
            "generalConfig",
            "RESPONSE_MSG",
            res.msgCode
          );
          msg = msg.replace("{0}", res.data?.employeeId);
          msg = msg.replace("{1}", res.data?.cardNumber);
        }
        clearAlerts();
        if (!msg) {
          msg = `Successfully ${id ? "updated" : "created"} the employee`;
        }
        setAlert(msg, res.status === "ERROR" ? "danger" : "info");
        loadSearchResults();
        setNavigationPage("Employee");
        // history.push(prevLocation);
        history.goBack();
        setValueChanged(false);
      } catch (err) {
        console.log("$ERR:", err.message);
        // const msg = getConfigValueByCode(
        //   "generalConfig",
        //   "RESPONSE_MSG",
        //   500
        // );
        clearAlerts();
        // setAlertTarget("Unexpected Error Occured", "danger", prevLocation);
        const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 475);
        setAlert(msg, "danger");
      }
    }
  };

  const loadGroups = async () => {
    try {
      const res = await getGroups({}, token);
      console.log("$$RES: ", res);
      if (res && res.msgCode) {
        const msg = getConfigValueByCode(
          "generalConfig",
          "RESPONSE_MSG",
          res.msgCode
        );
        clearAlerts();
        setAlert(msg, "warning");
      } else if (res.length === 0) {
        clearAlerts();
        const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 469);
        setAlert(msg, "warning");
      }
    } catch (err) {
      console.log("$ERR:", err);
      if (err.msgCode) {
        const msg = getConfigValueByCode(
          "generalConfig",
          "RESPONSE_MSG",
          err.msgCode
        );
        clearAlerts();
        setAlert(msg, "warning");
      }
      clearAlerts();
      const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 475);
      setAlert(msg, "danger");
    }
  };

  const {
    Popup,
    validateField,
    validateAllFields,
    isFormValid,
    setIsFormValid,
    unformattedValues,
    setUnformattedValues,
  } = useForm({
    inputList: {
      firstName: firstNameRef,
      lastName: lastNameRef,
      employeeid: employeeidRef,
      groupId: groupIdRef,
      employeeaddress: employeeaddressRef,
      city: cityRef,
      state: stateRef,
      zipCode: zipCodeRef,
      email: emailRef,
      phonenumber: phonenumberRef,
      cardNumber: cardNumberRef,
      contractId: contractIdRef,
    },
    unformattedValues: {
      phonenumber: "",
    },
    screenName: "create_employee",
  });

  useEffect(() => {
    const isValid = validateAllFields();
    setIsFormValid(isValid);
    console.log("Form is valid", isValid);
    //eslint-disable-next-line
  }, [employee]);

  useEffect(() => {
    if (!groupId && selectedEmployee) {
      const groupId = getGroupId(selectedEmployee.groupName);
      setEmployee({
        ...selectedEmployee,
        employeeid: selectedEmployee.employeeId,
        groupId,
      });
    }
    //eslint-disable-next-line
  }, [groups]);

  const getGroupId = (groupName) => {
    console.log("GEtting id for grpup : ", groupName);
    console.log("GEtting id for grpup : ", groups);
    if (groups && groups.data) {
      const group = groups.data.filter((item) => {
        return item.groupname === groupName;
      });
      if (group.length > 0) {
        console.log("SELECT GROUP:", group[0].id);
        return group[0].id;
      }
    }
    return "";
  };
  //console.log("##Groups for listing", groups);

  // const getContractDetails = () => {
  //   if (selectedCard) {
  //     let contract = selectedCard.contracts.filter(
  //       (item) => item.typeOfContract === 506
  //     );

  //     if (!contract.length > 0 && selectedCard.contracts[0]) {
  //       return [
  //         selectedCard.contracts[0].id,
  //         selectedCard.contracts[0].contractName,
  //       ];
  //     }

  //     return contract[0]
  //       ? [contract[0].id, contract[0].contractName]
  //       : ["", ""];
  //   }
  //   return ["", ""];
  // };
  // if (!stateCode && state) {
  //   const stateCode = getStateCode(state);
  //   setEmployee({ ...employee, stateCode });
  // }
  // if (!groupId && groupName) {
  //   const groupId = getGroupId(state);
  //   setEmployee({ ...employee, groupId });
  // }

  const renderContractList = () => {
    if (selectedEmployee && selectedEmployee.cardNumber)
      return (
        <option
          key={selectedEmployee.contractId}
          value={selectedEmployee.contractId}
        >
          {selectedEmployee.contractName}
        </option>
      );
    else if (selectedCard) {
      return selectedCard.contracts.map((contract) => (
        <option key={contract.id} value={contract.id}>
          {contract.contractName}
        </option>
      ));
    }
  };

  const [labels, setLabels] = useState({
    firstname: "",
    lastname: "",
    employeeId: "",
    employeeAddress: "",
    city: "",
    state: "",
    zipcode: "",
    email: "",
    phonenumber: "",
    cardnumber: "",
    groupName: "",
    contractType: "",
  });
  useEffect(() => {
    let cardNumber = "";
    if (selectedEmployee) {
      // const groupId = getGroupId(selectedEmployee.groupName);
      const stateValue = getStateByCode(selectedEmployee.state);
      const groupId = getGroupId(selectedEmployee.groupName);
      emailRef.current.value = selectedEmployee.email;
      setEmployee({
        ...selectedEmployee,
        employeeid: selectedEmployee.employeeId,
        zipCode: selectedEmployee.zipcode,
        stateValue,
        groupId,
      });
    } else if (selectedCard) {
      console.log("SELECTED CARD:", selectedCard);
      cardNumber = selectedCard.serialNumber;
      // [contractId, contractName] = getContractDetails();
      setEmployee({
        ...employee,
        cardNumber,
        // contractId,
        // contractName,
      });
    }
    // }, [selectedEmployee]);
    // useEffect(() => {

    const getGroupsList = async () => {
      await loadGroups();
    };
    if (!groups) getGroupsList();
    // setGroupId(getGroupId(selectedEmployee.groupName));
    let firstname = getConfigValueByName(
      "generalConfig",
      "Label",
      "label.firstname"
    );
    let lastname = getConfigValueByName(
      "generalConfig",
      "Label",
      "label.lastname"
    );
    let employeeId = getConfigValueByNameSponser(
      "generalConfig",
      "Label",
      "label.employeeId"
    );
    let employeeAddress = getConfigValueByNameSponser(
      "generalConfig",
      "Label",
      "label.employeeAddress"
    );
    let city = getConfigValueByName("generalConfig", "Label", "label.city");
    let state = getConfigValueByName("generalConfig", "Label", "label.state");
    let zipcode = getConfigValueByName(
      "generalConfig",
      "Label",
      "label.zipcode"
    );
    let email = getConfigValueByName("generalConfig", "Label", "label.email");
    let phonenumber = getConfigValueByName(
      "generalConfig",
      "Label",
      "label.phonenumber"
    );
    let cardnumber = getConfigValueByName(
      "generalConfig",
      "Label",
      "label.cardNumber"
    );
    let groupName = getConfigValueByNameSponser(
      "generalConfig",
      "Label",
      "label.groupName"
    );
    let contractType = getConfigValueByNameSponser(
      "generalConfig",
      "Label",
      "label.rsContractType"
    );
    setLabels({
      ...labels,
      firstname,
      lastname,
      employeeId,
      employeeAddress,
      city,
      state,
      zipcode,
      email,
      phonenumber,
      cardnumber,
      groupName,
      contractType,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Fragment>
      <Popup />
      {(employeesLoading || groupsLoading) && <Preloader />}
      <ActionMenu resetUseIdleTimer={props.resetUseIdleTimer} />
      <div
        className="patronPage"
        role="main"
        ref={props.mainContentRef}
        tabIndex="-1"
      >
        <h1 id="pageHeader" className="privateView__pageTitle">
          {selectedEmployee ? "UPDATE EMPLOYEE DETAILS" : "EMPLOYEE DETAILS"}
          <div className="privateView__pageTitle__note">
            {/* <span className="required">*</span>denotes a required field */}
          </div>
        </h1>
        <div className="patronPage__content">
          <div className="patronPage__card_form">
            <Form noValidate>
              <Form.Group as={Row}>
                <Col xs lg="4">
                  <Form.Label htmlFor="firstName">
                    {labels.firstname}{" "}
                    <span className="required" aria-label="Input required">
                      (*Required)
                    </span>
                    :{" "}
                  </Form.Label>
                </Col>
                <Col xs lg="4">
                  <Form.Control
                    aria-required="true"
                    className="mb-2"
                    id="firstName"
                    name="firstName"
                    placeholder={labels.firstname}
                    onChange={onChange}
                    value={firstName}
                    onBlur={validateField}
                    ref={firstNameRef}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Col xs lg="4">
                  <Form.Label htmlFor="lastName">
                    {labels.lastname}{" "}
                    <span className="required" aria-label="Input required">
                      (*Required)
                    </span>
                    :{" "}
                  </Form.Label>
                </Col>
                <Col xs lg="4">
                  <Form.Control
                    aria-required="true"
                    className="mb-2"
                    id="lastName"
                    name="lastName"
                    placeholder={labels.lastname}
                    onChange={onChange}
                    value={lastName}
                    onBlur={validateField}
                    ref={lastNameRef}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Col xs lg="4">
                  <Form.Label htmlFor="employeeid">
                    {labels.employeeId}
                    <span className="required" aria-label="Input required">
                      (*Required)
                    </span>
                    :{" "}
                  </Form.Label>
                </Col>
                <Col xs lg="4">
                  <Form.Control
                    aria-required="true"
                    className="mb-2"
                    id="employeeid"
                    name="employeeid"
                    placeholder={labels.employeeId}
                    onChange={onChange}
                    value={employeeid}
                    onBlur={validateField}
                    ref={employeeidRef}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Col xs lg="4">
                  <Form.Label htmlFor="employeeaddress">
                    {labels.employeeAddress} :
                  </Form.Label>
                </Col>
                <Col xs lg="4">
                  <Form.Control
                    className="mb-2"
                    id="employeeaddress"
                    name="employeeaddress"
                    placeholder={labels.employeeAddress}
                    onChange={onChange}
                    value={employeeaddress}
                    onBlur={validateField}
                    ref={employeeaddressRef}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Col xs lg="4">
                  <Form.Label htmlFor="city">{labels.city} :</Form.Label>
                </Col>
                <Col xs lg="4">
                  <Form.Control
                    className="mb-2"
                    id="city"
                    name="city"
                    placeholder={labels.city}
                    onChange={onChange}
                    value={city}
                    onBlur={validateField}
                    ref={cityRef}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Col xs lg="4">
                  <Form.Label htmlFor="state" id="state">
                    {labels.state}:
                  </Form.Label>
                </Col>
                <Col xs lg="4">
                  <select
                    name="state"
                    id="state"
                    className="form-control mb-2"
                    onChange={onChange}
                    value={state}
                    onBlur={validateField}
                    ref={stateRef}
                    placeholder={labels.state}
                  >
                    <option value="">--Select--</option>
                    {stateList.length > 0 &&
                      stateList.map((ele) => (
                        <option value={ele.code} key={ele.code}>
                          {ele.state}
                        </option>
                      ))}
                  </select>
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Col xs lg="4">
                  <Form.Label htmlFor="zipCode">{labels.zipcode} :</Form.Label>
                </Col>
                <Col xs lg="4">
                  <Form.Control
                    className="mb-2"
                    id="zipCode"
                    name="zipCode"
                    placeholder={labels.zipcode}
                    onChange={onChange}
                    value={zipCode}
                    onBlur={validateField}
                    ref={zipCodeRef}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Col xs lg="4">
                  <Form.Label htmlFor="email">{labels.email} :</Form.Label>
                </Col>
                <Col xs lg="4">
                  <Form.Control
                    className="mb-2"
                    id="email"
                    name="email"
                    type="email"
                    placeholder={labels.email}
                    onChange={onChange}
                    onBlur={validateField}
                    ref={emailRef}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Col xs lg="4">
                  <Form.Label htmlFor="phonenumber">
                    {labels.phonenumber} :
                  </Form.Label>
                </Col>
                <Col xs lg="4">
                  <NumberFormat
                    className="mb-2 form-control"
                    id="phonenumber"
                    name="phonenumber"
                    onValueChange={(values) => {
                      phoneNoChange(values.value, values.floatValue);
                    }}
                    placeholder={labels.phonenumber}
                    value={phonenumber}
                    onBlur={validateField}
                    getInputRef={phonenumberRef}
                    format="+1 ### ### ####"
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Col xs lg="4">
                  <Form.Label htmlFor="cardNumber">
                    {labels.cardnumber}{" "}
                    <span className="required" aria-label="Input required">
                      (*Required)
                    </span>
                    :{" "}
                  </Form.Label>
                </Col>
                <Col xs lg="4">
                  <Form.Control
                    aria-required="true"
                    className="mb-2"
                    id="cardNumber"
                    name="cardNumber"
                    placeholder={labels.cardnumber}
                    onChange={onChange}
                    value={cardNumber}
                    onBlur={validateField}
                    ref={cardNumberRef}
                    disabled
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Col xs lg="4">
                  <Form.Label htmlFor="groupId" id="groupName">
                    {labels.groupName}
                    <span className="required" aria-label="Input required">
                      (*Required)
                    </span>
                    :{" "}
                  </Form.Label>
                </Col>
                <Col xs lg="4">
                  <Form.Control
                    aria-required="true"
                    as="select"
                    className="mb-2"
                    onChange={onChange}
                    placeholder={labels.groupName}
                    value={groupId}
                    name="groupId"
                    id="groupId"
                    onBlur={(e) => validateField(e, labels.groupName)}
                    ref={groupIdRef}
                  >
                    <option value="">--SELECT--</option>
                    {groups &&
                      groups.data &&
                      groups.data.map((group) => (
                        <option key={group.id} value={group.id}>
                          {group.groupname}
                        </option>
                      ))}
                  </Form.Control>
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Col xs lg="4">
                  <Form.Label htmlFor="contractId" id="contract">
                    {labels.contractType}
                    <span className="required" aria-label="Input required">
                      (*Required)
                    </span>
                    :{" "}
                  </Form.Label>
                </Col>
                <Col xs lg="4">
                  <Form.Control
                    aria-required="true"
                    as="select"
                    className="mb-2"
                    onChange={onChange}
                    value={contractId}
                    name="contractId"
                    id="contractId"
                    onBlur={(e) => validateField(e, labels.contractType)}
                    ref={contractIdRef}
                  >
                    <option value="">--SELECT--</option>
                    {renderContractList()}
                    {/* {selectedCard &&
                      selectedCard.contracts.map((contract) => (
                        <option key={contract.id} value={contract.id}>
                          {contract.contractName}
                        </option>
                      ))} */}
                  </Form.Control>
                  {/* <Form.Check
                    className="mb-3"
                    type="checkbox"
                    id="contractId"
                    label={contractName}
                    onChange={onChange}
                    value={contractId}
                    checked={true}
                    disabled={true}
                    onBlur={validateField}
                    ref={contractIdRef}
                  /> */}
                </Col>
              </Form.Group>
              <Row xs="auto">
                <Col>
                  <Button onClick={cancelAction}>BACK</Button>
                </Col>
                <Col>
                  <Button
                    aria-label="Save"
                    type="submit"
                    onClick={submitForm}
                    disabled={!isFormValid || !valueChanged}
                  >
                    SAVE
                  </Button>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Employee;
